import { t } from "../../validation/validator";
import { timestampCodec } from "../../validation/codecs";

// Team Record
export const TeamRecord = t.type({
    id: t.number,
    doc_id: t.union([t.string, t.null]),
    created_at: timestampCodec,
    updated_at: t.union([timestampCodec, t.null]),
    license_provider_id: t.union([t.number, t.null]),
    club_id: t.union([t.number, t.null]),
    name: t.union([t.string, t.null]),
    group: t.union([t.string, t.null])
});

export type TeamRecord = t.TypeOf<typeof TeamRecord>;

// Team Insert
export const TeamInsert = t.partial({
    doc_id: t.union([t.string, t.null]),
    license_provider_id: t.union([t.number, t.null]),
    club_id: t.union([t.number, t.null]),
    name: t.string,
    group: t.union([t.string, t.null])
});

export type TeamInsert = t.TypeOf<typeof TeamInsert>;

// Update Team Schema
export const UpdateTeamSchema = t.intersection([
    t.type({
        action: t.union([t.literal('add'), t.literal('update'), t.literal('remove')]),
        account_id: t.number
    }),
    t.partial({
        team_id: t.number, // Required for update/remove, optional for add
        user_id: t.number, // For team-user association
        role: t.union([t.literal('member'), t.literal('admin')]), // For team-user role
        doc_id: t.union([t.string, t.null]),
        license_provider_id: t.union([t.number, t.null]),
        club_id: t.union([t.number, t.null]),
        name: t.union([t.string, t.null]),
        group: t.union([t.string, t.null])
    })
]);

export type UpdateTeamRequest = t.TypeOf<typeof UpdateTeamSchema>;

// Account Team Record
export const AccountTeamRecord = t.type({
    account_id: t.number,
    team_id: t.number
});

export type AccountTeamRecord = t.TypeOf<typeof AccountTeamRecord>;

// Team User Record
export const TeamUserRecord = t.type({
    team_id: t.number,
    user_id: t.number,
    role: t.union([t.literal('member'), t.literal('admin')])
});

export type TeamUserRecord = t.TypeOf<typeof TeamUserRecord>; 